import { render, staticRenderFns } from "./ModalPublish.vue?vue&type=template&id=509b693a&"
import script from "./ModalPublish.vue?vue&type=script&lang=js&"
export * from "./ModalPublish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports